// src/pages/CreateExamPage.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './CreateExamPage.css';

const CreateExamPage = () => {
  const [isCreating, setIsCreating] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const createExam = async () => {
    setIsCreating(true);
    setError('');
    
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/create-exam`);
      const { exam_code } = response.data;
      navigate(`/exam/${exam_code}`);
    } catch (err) {
      setError('Erro ao criar a prova. Por favor, tente novamente.');
      console.error('Erro:', err);
    } finally {
      setIsCreating(false);
    }
  };

  return (
    <div className="create-exam-container">
      <span className="create-exam-eyebrow">Área administrativa</span>
      <h2>Criar nova avaliação</h2>
      <p>
        Gera uma nova prova com 20 questões de múltipla escolha (Português e
        Matemática), sorteadas automaticamente. O candidato terá 2 horas para
        concluí-la.
      </p>
      <button
        className="create-exam-btn"
        onClick={createExam}
        disabled={isCreating}
      >
        {isCreating ? 'Criando...' : 'Criar Nova Avaliação'}
      </button>
      {error && <p className="error-message">{error}</p>}
    </div>
  );
};

export default CreateExamPage;